/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungDto } from '../../models/buchung-dto';
import { CreateBuchungForTimeframeDto } from '../../models/create-buchung-for-timeframe-dto';

export interface CreateBuchungForMitarbeiterInTimeframe$Plain$Params {

/**
 * ID des Mitarbeiters
 */
  mitarbeiterId: string;
  
    /**
     * Daten für die Buchung
     */
    body?: CreateBuchungForTimeframeDto
}

export function createBuchungForMitarbeiterInTimeframe$Plain(http: HttpClient, rootUrl: string, params: CreateBuchungForMitarbeiterInTimeframe$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungDto>>> {
  const rb = new RequestBuilder(rootUrl, createBuchungForMitarbeiterInTimeframe$Plain.PATH, 'post');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BuchungDto>>;
    })
  );
}

createBuchungForMitarbeiterInTimeframe$Plain.PATH = '/v1/mitarbeiter/{mitarbeiterId}/buchungen/timeframe';
